// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1-lZk","footer":"ModalCreateQualiphyProcedure_footer__2lOD4","additionData":"ModalCreateQualiphyProcedure_additionData__2O1in"};